import { Header, LoadingSpinner, ServiceCard } from '@psyomics/ui-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useProfessionalReferralServices } from './hooks/use-professional-referral-services';

const groupServicesByOrganisation = (services: ReturnType<typeof useProfessionalReferralServices>['services']) => {
  const groups = new Map<
    string,
    { organisation: (typeof services)[number]['organisation']; services: (typeof services)[number]['service'][] }
  >();

  services.forEach(({ organisation, service }) => {
    const group = groups.get(organisation.code);

    if (group) {
      group.services.push(service);
    } else {
      groups.set(organisation.code, { organisation, services: [service] });
    }
  });

  return Array.from(groups.values());
};

const AvailableServices = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { services, fetching } = useProfessionalReferralServices();
  const organisationGroups = groupServicesByOrganisation(services);

  return (
    <>
      <Header className="mt-3" level="h2">
        {t('page.professionalReferral.home.availableServices')}
      </Header>
      {fetching ? (
        <LoadingSpinner />
      ) : (
        organisationGroups.map(({ organisation, services: organisationServices }) => (
          <div className="flex flex-col gap-3 mt-4" key={organisation.code}>
            {organisationGroups.length > 1 && (
              <Header className="mt-2" level="h3">
                {organisation.name}
              </Header>
            )}
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
              {organisationServices.map((service) => (
                <ServiceCard
                  description={service.referrerDescription ?? undefined}
                  key={service.code}
                  onClick={() => navigate(`/referral-request/${organisation.code}/${service.code}/create`)}
                  title={service.description}
                />
              ))}
            </div>
          </div>
        ))
      )}
    </>
  );
};

export { AvailableServices };
